import { render, staticRenderFns } from "./FeJoseAngeCruz.vue?vue&type=template&id=207426f6&"
import script from "./FeJoseAngeCruz.vue?vue&type=script&lang=js&"
export * from "./FeJoseAngeCruz.vue?vue&type=script&lang=js&"
import style0 from "./FeJoseAngeCruz.vue?vue&type=style&index=0&id=207426f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports